import { getDictionary, getResourceList } from '@/api/common/index';

let dictMap = {}; // 字典值
let permissionList = []; // 权限列表

// 对币种显示做处理  label = value + description
const CURRENCY_KEYS_MAP = {
  CURRENCY: true,
  PAYOUT_CURRENCY: true,
  SETTLE_CURRENCY_CONFIG: true,
  VA_BIZ_CURRENCY: true,
  FX_BUY_CURRENCY: true,
  FX_SELL_CURRENCY: true,
  FX_CURRENCY: true,
};
const formatCurrency = (data = {}) => {
  try {
    const keys = Object.keys(data);
    keys.forEach((k) => {
      if (CURRENCY_KEYS_MAP[k]) { // 存在需要处理的币种时
        const list = data[k];
        data[k] = list.map((item) => {
          item.label = `${item.value}-${item.description}`;
          return item;
        });
      }
    });
  } catch (err) {
    //
  }
  return data;
};

/**
 * 获取字典数据
 * @param {Array} codes - 需要获取的字典代码数组，支持的代码包括：
 * - 交易相关: 'TXN_TYPE', 'TXN_STATUS', 'MERC_TXN_STATUS', 'TXN_PURPOSE', 'TXN_TYPE_ACCOUNT', 'SUBPRODUCT_TYPE'
 * - 产品相关: 'PRODUCT_TYPE', 'SUBPRODUCT_TYPE', 'WEB_TYPE'
 * - 支付方式相关: 'CREDIT_CARD_TYPE', 'PAYMENT_METHOD', 'CARRIER'
 * - 退款相关: 'MERC_REFUND_STATUS', 'FEE_STATUS'
 * - 拒付相关: 'MERC_CHARGEBACK_STATUS', 'CHARGEBACK_STATUS', 'DISPUTE_DAYS_LEFT', 'DISPUTE_REASON'
 * - 结算相关: 'MERC_SETTLE_STATUS', 'SETTLE_STATUS_PAYOUT', 'SHARE'
 * - 转账相关: 'MER_PAYOUT_STATUS', 'TRANSFER_METHOD', 'PAYOUT_CURRENCY'
 * - 收款人相关: 'PAYEE_STATUS', 'MATERIAL_NAME', 'MATERIAL_NAME_URL'
 * - 银行相关: 'BANK_NAME'
 * - 货币相关: 'FX_CURRENCY'
 * - 账户相关: 'SUB_ACNT_TYPE', 'WALLET_TYPE_CODE', 'MER_FX_TXN_STATUS'
 * - 国家相关: 'COUNTRY'
 * - 订阅相关: 'SUBSCRIPTION_STATUS', 'SUBSCRIPTION_PAYMENT_METHOD'
 * - 风控相关: 'ETHOCA_ACW_OUTCOME', 'ETHOCA_ACW_REFUND_STATUS', 'RDR_ACW_PRE_DISPUTE_SERVICE',
 *            'ACW_ENROLLMENT_STATUS', 'ETHOCA_ACW_PRE_DISPUTE_SERVICE', 'RDR_ACW_STATUS', 'RDR_ACW_CASE_TYPE'
 * - 上传相关: 'MERC_UPLOAD_TYPE', 'UPLOAD_STATUS', 'AUDIT_STATUS', 'CHARGEBACK_APPEAL_FILE_TYPE', 'CHARGEBACK_APPEAL_GOODS_TYPE'
 * - 虚拟账户相关: 'VA_BIZ_TYPE', 'VA_BIZ_CURRENCY', 'VA_STATUS', 'MER_PAYIN_STATUS'
 * - 第三方平台相关: 'AMAZON_EU_MARKETPLACE', 'AMAZON_US_MARKETPLACE', 'AMAZON_JP_MARKETPLACE',
 *                'EBAY_MARKETPLACE', 'SALES_CATEGORIES', 'EXPECTED_ANNUAL_SALES'
 * @param {boolean} refresh - 是否强制刷新字典数据缓存
 * @returns {Promise<Object>} - 返回字典数据对象
 */
const getDictList = async (codes = [], refresh = false) => {
  try {
    if (refresh) { // 若是强制刷新则清空
      dictMap = {};
    }
    const dict = {};
    const codeList = [];
    for (let i = 0; i < codes.length; i++) {
      const code = codes[i];
      const arr = dictMap[codes[i]];
      if (arr) {
        // 之前以获取过该字典时，复用
        dict[code] = arr;
      } else {
        codeList.push(code);
      }
    }
    if (codeList.length > 0) {
      const res = await getDictionary(codeList);
      const data = formatCurrency(res);
      Object.assign(dictMap, data);
      Object.assign(dict, data);
    }
    return dict;
  } catch (err) {
    console.log('getDictionary: ', err);
  }
  return {};
};

/**
 * 获取权限资源列表
 * @param {*} refresh 是否刷新
 */
const getPermissionList = async (refresh = false) => {
  try {
    if (permissionList.length === 0 || refresh) {
      permissionList = await getResourceList();
    }
  } catch (err) {
    console.log('global getPermissionList: ', err);
  }
  return permissionList;
};

export default {
  getDictList,
  getPermissionList,
};
